/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Submit_Flow_Step2Inputs */

const en_directory_submit_flow_step2 = /** @type {(inputs: Directory_Submit_Flow_Step2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Content`)
};

const zh_directory_submit_flow_step2 = /** @type {(inputs: Directory_Submit_Flow_Step2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`内容`)
};

/**
* | output |
* | --- |
* | "Content" |
*
* @param {Directory_Submit_Flow_Step2Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_submit_flow_step2 = /** @type {((inputs?: Directory_Submit_Flow_Step2Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Submit_Flow_Step2Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_submit_flow_step2(inputs)
	return zh_directory_submit_flow_step2(inputs)
});
export { directory_submit_flow_step2 as "directory.submit.flow.step2" }